import axiosInstance from 'services/APIService';

const ENDPOINT_PATH = `/v1/user`;

export interface User {
  archived: boolean;
  auth0_id: string;
  auth0_org_id: string | null;
  auth0_role_id: string | null;
  email: string;
  location_id: string | null;
  user_id: string;
}

interface Role {
  id: string;
  name: string;
  description: string;
}

export interface Organisation {
  tenant_id: string;
  description: string;
  name: string;
  auth0_org_id: string;
}

interface Location {
  location_id: string;
  description: string;
  name: string;
}

/**
 * List users
 * @returns List of users
 */
export const listUsers = async (orgId: string): Promise<User[]> => {
  const { data } = await axiosInstance.get<User[]>(`${ENDPOINT_PATH}/${orgId}/list`);

  return data;
};

export const listTenants = async (): Promise<Organisation[]> => {
  const { data } = await axiosInstance.get<Organisation[]>(`${ENDPOINT_PATH}/tenants`);

  return data;
};

/**
 * List roles
 * @returns List of roles
 */
export const listRoles = async (orgId: string): Promise<Role[]> => {
  const { data } = await axiosInstance.get<Role[]>(`${ENDPOINT_PATH}/${orgId}/roles`);

  return data;
};

/**
 * List locations
 * @returns List of locations
 */
export const listLocations = async (orgId: string): Promise<Location[]> => {
  const { data } = await axiosInstance.get<Location[]>(`${ENDPOINT_PATH}/${orgId}/locations`);

  return data;
};

/**
 * Update users
 * @returns void or error
 */
export const updateUsers = async (users: User[]): Promise<void> => {
  await axiosInstance.put<void>(`${ENDPOINT_PATH}/`, { users });

  return;
};

/**
 * Create user
 * @returns void or error
 */
export const createUser = async (
  email: string,
  auth0_role_id?: string,
  auth0_org_id?: string,
  location_id?: string,
): Promise<void> => {
  await axiosInstance.post<void>(`${ENDPOINT_PATH}/add_user`, { email, auth0_role_id, auth0_org_id, location_id });

  return;
};

/**
 * Delete user
 * @returns void or error
 */
export const deleteUser = async (userId: string): Promise<void> => {
  await axiosInstance.delete<void>(`${ENDPOINT_PATH}/${userId}`);

  return;
};
